import { Component, Input, OnInit } from '@angular/core';
import { ILink } from '../models/common-model-interface';

@Component({
  selector: 'gn-header-account',
  templateUrl: './header-account.component.html',
  styleUrls: ['./header-account.component.scss']
})
export class HeaderAccountComponent implements OnInit {
  alertCount: number;

  @Input() userName: string;
  @Input() accountLinks: Array<ILink>;
  @Input() domain: string;
  @Input() alertsUrl: string;

  constructor() { }

  ngOnInit(): void {
  }

}
